<template>  
    <div>
        <b-row>
            <b-col style="margin-left: 10px;margin-right: 10px;">
                <b-row cols="12" style="margin-left: 5px;margin-right: 5px;">
                    <b-input-group size="sm">
                        <b-form-input
                            v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Consulta ..."
                        ></b-form-input>
                    <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
                    </b-input-group-append>
                    </b-input-group>
                </b-row>
            </b-col>
        </b-row>
        <b-table
            hover
            responsive
            selectable
            select-mode="single"
            small
            :id="id"            
            :primary-key="primaryKey"
            :items="items"
            :fields="fields"            
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"            
            @filtered="onFiltered"
            @row-selected="onRowSelected">
        
        </b-table>
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="my-table"
            align="right">
        </b-pagination>         
    </div>
</template>

<script>

export default {
    name: 'ConsultaProdutoTable',
    
    props: {
        id: String,
        primaryKey: String,
        items: Array,
        fields: Array,
        filterOn: Array,        
        onSelect: {
            type: Function,
            default: null,
        },        
        perPage: {
            type: Number,
            default: 15
        },        
    },

    data() {
        return {
            search: "",
            filter: "",
            currentPage: 1,
            totalRows: 0,
            selected: [],            
        };
    },

    beforeMount: function() {
        this.totalRows = this.items.length
    },

    updated: function(){
        this.totalRows = this.items.length
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;                  
        },   

        onRowSelected(item) {            
            this.onSelect(item[0]);
        },        
    },    
}
</script>